import apiFetch from "@/src/utils/apiFetch";

import {
  ExamStep,
  PatientItemStatus,
  patientItemStatuses,
} from "@/src/data/allTypes";

import { Button } from "@/src/components/buttons";
import { Card } from "@/src/components/cards";
import {
  closeDialog,
  openConfirmDialog,
  openDeleteDialog,
  openDialog,
} from "@/src/components/dialogs";
import { Input } from "@/src/components/universalInput";
import { getServiceId, getUserId } from "@/src/utils/utils";
import { FaRegTrashAlt } from "react-icons/fa";
import { openUsersCheckboxList } from "../admin/users/usersHook";

export async function openAnapathStepActionsDialog({
  step,
  onChange,
}: {
  step: ExamStep;
  onChange: (exam: ExamStep) => void;
}) {
  function close() {
    closeDialog("anapathStepActions");
  }

  return await openDialog({
    id: "anapathStepActions",
    title: "Statut de l'examen",
    content: (
      <div className="c1 gap10">
        <Button
          onClick={async () => {
            close();
            await openAnapathStepStatusDialog({
              step,
              onChange: (step) => {
                onChange(step);
                close();
              },
            });
          }}
        >
          Changer statut
        </Button>
        <Button
          type={"tertiary"}
          onClick={async () => {
            close();
            await openUsersCheckboxList({
              serviceId: getServiceId(),
              title: "Choisir les utilisateurs",
              selectedUsers: (step.affectedTo || []).filter(
                (user) => user != null
              ),
              onConfirm: async (users) => {
                step = await apiFetch("examSteps", "addOne", {
                  examstep: {
                    id: step.id,
                    affectedTo: users,
                  } as ExamStep,
                });
                onChange(step);
              },
            });
          }}
        >
          Assigner à un utilisateur
        </Button>
        <Button
          type={"tertiary"}
          onClick={async () => {
            close();
            await openNotesDialog({
              step,
              onConfirm: async (step) => {
                step=  await apiFetch("examSteps", "addOne", {
                  examstep: {
                    id: step.id,
                    notes: step.notes,
                  } as ExamStep,
                });
                onChange(step);
              },
            });
          }}
        >
          Ajouter des notes
        </Button>
        <Button
          type={"tertiary"}
          color="red"
          onClick={async () => {
            close();
            await openConfirmDialog({
              id: "deleteExamStep",
              title: "Supprimer l'étape",
              content: "Voulez-vous vraiment supprimer l'étape ?",
              onConfirm: async () => {
                await apiFetch("examSteps", "deleteOne", {
                  id: step.id,
                });
                onChange(step);
                closeDialog("deleteExamStep");
              },
            });
          }}
        >
          Supprimer
        </Button>
      </div>
    ),
  });
}

export async function openAnapathStepStatusDialog({
  step,
  onChange,
}: {
  step: ExamStep;
  onChange: (exam: ExamStep) => void;
}) {
  const allowedStatuses: PatientItemStatus[] = [
    "pending",
    "inProgress",
    "finished",
    "problem",
  ];

  async function openConclusionDialog({
    step,
    onConfirm,
  }: {
    step: ExamStep;
    onConfirm: (step: ExamStep) => void;
  }) {
    await openDialog({
      id: "anapathStepNotes",
      title: "Notes",
      content: (
        <div>
          <Input
            type="textarea"
            shouldFocus={true}
            rows={6}
            name={""}
            value={step.conclusion}
            onChange={(newValue) => {
              step.conclusion = newValue;
            }}
          ></Input>
        </div>
      ),
      onConfirm: async () => {
        onConfirm(step);
      },
    });
  }

  await openDialog({
    id: "anapathStepStatus",
    title: (
      <div className="c1-auto gap5 acenter">
        <div>Changer statut</div>
        {
          <Button
            color="red"
            type={"tertiary"}
            onClick={async () => {
              openDeleteDialog(async () => {
                closeDialog("anapathStepStatus");
                await apiFetch("examSteps", "deleteOne", {
                  id: step.id,
                });
                onChange(step);
              });
            }}
          >
            <FaRegTrashAlt size={16} />
          </Button>
        }
      </div>
    ),

    content: (
      <div className="c1 gap10">
        {Object.values(patientItemStatuses)
          .filter((statusInfo) => allowedStatuses.includes(statusInfo.id))
          .map((statusInfo) => (
            <Card
              key={statusInfo.id}
              onClick={async () => {
                await openConclusionDialog({
                  step,
                  onConfirm: async (step) => {
                    step = await apiFetch("examSteps", "addOne", {
                      examstep: {
                        id: step.id,
                        status: statusInfo.id,
                        conclusion: step.conclusion,
                        doneBy: getUserId(),
                      } as ExamStep,
                    });
                    closeDialog("anapathStepStatus");
                    onChange(step);
                  },
                });
              }}
            >
              <div style={{ color: statusInfo.color }} className="bold">
                {statusInfo.name}
              </div>
            </Card>
          ))}
      </div>
    ),
  });
}

async function openNotesDialog({
  step,
  onConfirm,
}: {
  step: ExamStep;
  onConfirm: (step: ExamStep) => void;
}) {
  await openDialog({
    id: "anapathStepNotes",
    title: "Notes",
    content: (
      <div>
        <Input
          type="textarea"
          shouldFocus={true}
          rows={6}
          name={""}
          value={step.notes}
          onChange={(newValue) => {
            step.notes = newValue;
          }}
        ></Input>
      </div>
    ),
    onConfirm: async () => {
      onConfirm(step);
    },
  });
}
